// extracted by mini-css-extract-plugin
export var activityContainer = "_hf-0";
export var typingIndicatorContainer = "_hf-1";
export var typingIndicatorDot = "_hf-2";
export var wave = "_hf-3";